import { createTypedValidator } from '@takeshape/json-schema';
export const schema = {
    type: 'object',
    properties: {
        sessionId: {
            type: 'string',
            description: 'Session ID to of the agent session to inspect.'
        }
    },
    required: ['sessionId'],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
